import React, { useEffect, useState, useRef } from 'react';
import "./ServiceMaster.css";
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { addServices, getAllServices } from '../../../services/roleServiceMapService';

const ServiceMaster = () => {
  const navigate = useNavigate();
  const effectRan = useRef(false);

  const [serviceId, setServiceId] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serviceLink, setServiceLink] = useState("");
  const [type, setType] = useState("MENU"); // ✅ ENUM support
  const [parentOptions, setParentOptions] = useState([]);
  const [parent, setParent] = useState(null);
  const [displayOrder, setDisplayOrder] = useState(1);
  const [allServices, setAllServices] = useState([]);
  const [description, setDescription] = useState("");
  const Cancel = () => {
    navigate("/addService");
  };

 const handleServiceNameChange = (e) => {
  const value = e.target.value;
  setServiceName(value);
  setDescription(value);
};

  // ✅ Auto detect MENU / FORM
  const handleServiceLink = (e) => {
    const value = e.target.value;
    setServiceLink(value);

    if (value && value !== "#") {
      setType("FORM");
    } else {
      setType("MENU");
    }
  };

  // ✅ Recursive dropdown builder (supports sub-child)
  const buildOptions = (services, level = 0) => {
    let opts = [];

    services.forEach((service) => {
      opts.push({
        value: service.serviceId,
        label: `${"— ".repeat(level)}${service.serviceName}`,
      });

      if (service.children?.length) {
        opts = opts.concat(buildOptions(service.children, level + 1));
      }
    });

    return opts;
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await getAllServices();
        setAllServices(data);

        const options = buildOptions(data); // ✅ recursion used
        setParentOptions(options);

      } catch (error) {
        console.error("Failed to fetch services:", error);
      }
    };

    if (!effectRan.current) {
      fetchServices();
    }

    return () => {
      effectRan.current = true;
    };
  }, []);

  // ✅ Generate next serviceId
  useEffect(() => {
    const fetchNextServiceId = async () => {
      try {
        const data = await getAllServices();

        const flatten = [];
        const flattenData = (services) => {
          services.forEach(s => {
            flatten.push(s);
            if (s.children?.length) flattenData(s.children);
          });
        };

        flattenData(data);

        const maxId = flatten.reduce(
          (max, item) => (item.serviceId > max ? item.serviceId : max),
          0
        );

        setServiceId(maxId + 1);
      } catch (error) {
        console.error("Failed to fetch max serviceId:", error);
      }
    };

    fetchNextServiceId();
  }, []);

  // ✅ Display order logic
  const getNextDisplayOrder = (parentId) => {
    let count = 0;

    if (!parentId) {
      count = allServices.length;
    } else {
      const findParent = (services) => {
        for (let s of services) {
          if (s.serviceId === parentId) return s;
          if (s.children?.length) {
            const found = findParent(s.children);
            if (found) return found;
          }
        }
        return null;
      };

      const parentService = findParent(allServices);
      count = parentService?.children?.length || 0;
    }

    return count + 1;
  };

  const handleAdd = async () => {
    try {
      const payload = {
        serviceName,
        serviceLink: serviceLink || '#',
        type, // ✅ ENUM sent to backend
        description,
        displayOrder,
        ...(parent && {
          parent: { serviceId: parent }
        })
      };

      const response = await addServices(payload);
      //console.log("Service added:", response.data);

      navigate("/addService");
    } catch (error) {
      console.error("Failed to add service:", error);
      alert("Something went wrong while adding the service.");
    }
  };

  return (
    <div className="service-image-main">
      <h2>Add Service Master</h2>

      {/* Service ID */}
      <div className="service-image">
        <div className={`service-input-group ${serviceId ? "filled" : ""}`}>
          <input type="text" value={serviceId} readOnly />
          <label>Service ID</label>
        </div>
      </div>

      {/* Service Name */}
      <div className="service-image">
        <div className={`service-input-group ${serviceName ? "filled" : ""}`}>
          <input type="text" value={serviceName} onChange={handleServiceNameChange} />
          <label>Service Name</label>
        </div>
      </div>

      {/* Parent */}
      <div className="service-image">
        <div className={`service-input-group ${parent ? "filled" : ""}`}>
          <Select
            options={parentOptions}
            value={parentOptions.find((opt) => opt.value === parent) || null}
            onChange={(selectedOption) => {
              const selectedParentId = selectedOption?.value ?? null;
              setParent(selectedParentId);

              const nextOrder = getNextDisplayOrder(selectedParentId);
              setDisplayOrder(nextOrder);
            }}
            isClearable
            placeholder=""
            className="user-select"
            classNamePrefix="user-select"
          />
          <label>Parent</label>
        </div>
      </div>

      {/* Service Link */}
      <div className="service-image">
        <div className={`service-input-group ${serviceLink ? "filled" : ""}`}>
          <input type="text" value={serviceLink} onChange={handleServiceLink} />
          <label>Service Link</label>
        </div>
      </div>

      {/* Type (readonly auto) */}
      <div className="service-image">
        <div className={`service-input-group ${type ? "filled" : ""}`}>
          <input type="text" value={type} readOnly />
          <label>Type</label>
        </div>
      </div>

      <div className="service-image">
        <div className={`service-input-group ${description ? "filled" : ""}`}>
          <input
            type="text"
            value={description}
            readOnly
          />
          <label>Description</label>
        </div>
      </div>

      {/* Display Order */}
      <div className="service-image">
        <div className={`service-input-group ${displayOrder ? "filled" : ""}`}>
          <input type="text" value={displayOrder} readOnly />
          <label>Display Order</label>
        </div>
      </div>

      {/* Buttons */}
      <div className='service-mst-btn'>
        <button className="add-btn-service-img" onClick={handleAdd}>Add</button>
        <button className="service-mst-cancel-img" onClick={Cancel}>Cancel</button>
      </div>
    </div>
  );
};

export default ServiceMaster;